import { render } from "./App.vue?vue&type=template&id=f544df30"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f544df30&lang=css"
import "@/assets/redesign.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../../../../labcheckup/labhub_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__